<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th>{{ $t("mall.交易信息") }}</th>
            <th>{{ $t("mall.买家联系信息") }}</th>
            <th class="wd-200">{{ $t("mall.类型") }}</th>
            <th class="wd-100">{{ $t("mall.状态") }}</th>
            <th class="wd-100">{{ $t("mall.金额") }}</th>
            <th class="wd-100">{{ $t("mall.备注") }}</th>
            <th class="wd-150">{{ $t("mall.时间") }}</th>
            <th class="wd-100">{{ $t("mall.操作") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="item.id">
            <td class="valign-middle">
              <p class="mg-b-5">
                <span v-if="item.payRecord.type == 1">{{
                  $t("mall.支付宝")
                }}</span>
                <span v-if="item.payRecord.type == 2">{{
                  $t("mall.微信")
                }}</span
                >{{ $t("mall.交易号：") }}
                <span class="tx-white">{{ item.payRecord.tradeCode }}</span>
                <a
                  v-if="item.payRecord.tradeCode"
                  class="to-clipboard"
                  href="javascript:;"
                  :data-clipboard-text="item.payRecord.tradeCode"
                >
                  <i class="icon ion-clipboard"></i>
                </a>
              </p>
              <p class="mg-b-5" v-if="item.payRecord">
                {{ $t("mall.系统交易号：") }}
                <span class="tx-white">{{ item.payRecord.payCode }}</span>
                <a
                  v-if="item.payRecord.payCode"
                  class="to-clipboard"
                  href="javascript:;"
                  :data-clipboard-text="item.payRecord.payCode"
                >
                  <i class="icon ion-clipboard"></i>
                </a>
              </p>
              <p class="mg-b-0">
                {{ $t("mall.订单号：") }}
                <span class="tx-white">{{ item.orderCode }}</span>
                <a
                  v-if="item.orderCode"
                  class="to-clipboard"
                  href="javascript:;"
                  :data-clipboard-text="item.orderCode"
                >
                  <i class="icon ion-clipboard"></i>
                </a>
              </p>
            </td>
            <td class="valign-middle">
              <!--<p class="mg-b-5">
            		企业ID：
            		<span class="tx-white">{{item.userInfo.outerId?item.userInfo.outerId:"---"}}</span>
            	</p>-->
              <p class="mg-b-5">
                {{ $t("mall.公司名称：") }}
                <span class="tx-white">{{
                  item.userInfo.name ? item.userInfo.name : "---"
                }}</span>
              </p>
              <p class="mg-b-5">
                {{ $t("mall.联系人：") }}
                <span class="tx-white">{{
                  item.contact ? item.contact : "---"
                }}</span>
              </p>
              <p class="mg-b-0">
                {{ $t("mall.联系电话：") }}
                <span class="tx-white">{{
                  item.mobile ? item.mobile : "---"
                }}</span>
              </p>
            </td>
            <td class="valign-middle">
              <div :class="item.type == 1 ? 'tx-success' : 'tx-danger'">
                {{ $t(payTypeArr[item.type]) }}
              </div>
            </td>
            <td class="valign-middle">
              <span :class="item.status == 2 ? 'tx-success' : 'tx-danger'">{{
                $t(payStatus[item.status])
              }}</span>
            </td>
            <td class="valign-middle">
              <span :class="item.type == 1 ? 'tx-success' : 'tx-danger'">
                <span v-if="item.type == 1">+ </span>
                <span v-if="item.type == 4">- </span>￥{{
                  item.amount ? parseFloat(item.amount).toFixed(2) : "---"
                }}
              </span>
            </td>
            <td class="valign-middle">
              <button
                @click="openModalRemark(index)"
                class="btn btn-dark remark"
                style="
                  background: transparent !important;
                  border: none !important;
                "
                :disabled="!item.remark && !item.distributorRemark"
                :style="{
                  cursor:
                    item.remark || item.distributorRemark
                      ? 'pointer'
                      : 'default',
                }"
              >
                <i
                  class="icon ion-chatbox-working tx-20"
                  :class="
                    !item.remark && !item.distributorRemark
                      ? 'tx-gray-100'
                      : 'tx-info'
                  "
                ></i>
              </button>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{ item.timeCreated }}</span>
            </td>
            <td class="valign-middle">
              <p class="mg-b-5" v-if="item.status == 1">
                <a
                  href="javascript:;"
                  class="tx-info"
                  @click="openModalRefund(index)"
                  >{{ $t("mall.退款处理") }}</a
                >
              </p>
              <p class="mg-b-0" v-if="item.type == 2 && item.status == 1">
                <a
                  href="javascript:;"
                  class="tx-info"
                  @click="openModalAudit(index)"
                  >{{ $t("mall.审核") }}</a
                >
              </p>
              <p class="mg-b-0" v-if="item.status == 1 && item.type == 3">
                <a href="javascript:;" class="tx-info" @click="delAdd(index)">{{
                  $t("mall.关闭")
                }}</a>
              </p>
            </td>
          </tr>
        </tbody>
        <tbody v-if="(!items || items.length < 1) && !first_loading">
          <tr>
            <td colspan="8">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{ $t("mall.没有符合条件的数据") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ["items", "first_loading"],
  data() {
    return {
      payTypeArr: arrDict.afterSaleType,
      payStatus: arrDict.accountStatus,
    };
  },
  computed: {},
  watch: {},
  methods: {
    openModalRefund(i) {
      this.$emit("openModalRefund", i);
    },
    delAdd(i) {
      this.$emit("delAdd", i);
    },
    openModalRemark(i) {
      this.$emit("openModalRemark", i);
    },
    openModalAudit(i) {
      this.$emit("openModalAudit", i);
    },
  },
};
</script>

